import React from "react";
import styled from 'styled-components';
import { COLOR_DESCRIPTION, DEVICES } from '../../const';
import logo from '../../assets/logo.png';

const Inner = styled.div`
  margin: auto;

  @media ${DEVICES.mobile} {
    display: block;
    padding: 1rem 0;
  }

  @media ${DEVICES.tablet} {
    display: flex;
    padding: 120px 0;
  }

  @media ${DEVICES.large} {
    display: flex;
    max-width: 1200px;
  }
`;

const Left = styled.div`
  padding: 0 2rem 2rem 2rem;
  @media ${DEVICES.mobile} {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  @media ${DEVICES.tablet} {
    width: 50%;
    align-items: start;
  }

  @media ${DEVICES.large} {
    width: 50%;
  }
`;

const LeftImg = styled.img`
  width: 100%;
  border-radius: 20px;
`;

const Right = styled.div`
  @media ${DEVICES.mobile} {
    padding: 2rem 2rem 80px 2rem;
  }

  @media ${DEVICES.tablet} {
    padding: 2rem;
    width: 50%;
  }

  @media ${DEVICES.large} {
    width: 50%;
  }
`;

const RightHeading = styled.div`

  @media ${DEVICES.mobile} {
    font-size: 1rem;
  }

  @media ${DEVICES.tablet} {
    font-size: 1rem;
  }

  @media ${DEVICES.laptop} {
    font-size: 1rem;
  }
`;

const RightTitle = styled.div`
  font-weight: 700;
  margin-top: 1rem;
  line-height: 48px;

  @media ${DEVICES.mobile} {
    font-size: 2rem;
  }

  @media ${DEVICES.tablet} {
    font-size: 1.5rem;
  }

  @media ${DEVICES.laptop} {
    font-size: 2.25rem;
  }
`;

const RightDescription = styled.div`
  margin-top: 2rem;
  color: ${COLOR_DESCRIPTION};
  @media ${DEVICES.mobile} {
    font-size: 1rem;
  }

  @media ${DEVICES.tablet} {
    font-size: 1rem;
  }

  @media ${DEVICES.laptop} {
    font-size: 1rem;
  }
`;

const RightDescriptionBold = styled.div`
  margin-top: 2rem;
  font-weight: 700;
  @media ${DEVICES.mobile} {
    font-size: 1rem;
  }

  @media ${DEVICES.tablet} {
    font-size: 1rem;
  }

  @media ${DEVICES.laptop} {
    font-size: 1rem;
  }
`;

export default function ExerciseBanner() {
  return (
    <Inner>
      <Left>
        <LeftImg src="https://kangaroo-edu-main.s3.ap-northeast-2.amazonaws.com/landing-page/home/exercise.jpg" />
      </Left>
      <Right>
        <RightHeading>
          아이들이 스스로 몸의 움직임을 <br />
          이해 할 수 있다면
        </RightHeading>
        <RightTitle>
          평생동안 운동을, <br />
          재미있게 할 수 있습니다
        </RightTitle>
        <RightDescription>
          우리 아이들은 호기심이 많고 탐구적입니다 <br />
          도전적이며 창의적이고 목표 지향적인 9가지의 기능성 운동을 통해 <br />
          아이들의 평생 습관을 책임지겠습니다
        </RightDescription>
        <RightDescriptionBold>
          건강한 신체에 건강한 정신이 깃들도록 <br />
          올바르게 지도하겠습니다
        </RightDescriptionBold>
      </Right>
    </Inner>
  )
}
